module.exports = __webpack_public_path__ + "static/media/01A.5435b407.png";